export const xSmall = 375;
export const small = 640;
export const medium = 768;
export const large = 1024;
export const xLarge = 1280;
export const xLarge2 = 1440;
export const xLarge3 = 1920;
export const xLarge4 = 2560;
